// ===============================================================
// ⭐ TopBar.js — Unified Header (FINAL / LOCKED)
// RTL / LTR safe — No language or direction logic
// ===============================================================

import React from "react";
import { useTranslation } from "react-i18next";
import "./TopBar.css";

export default function TopBar({ title, onBack }) {
  const { t } = useTranslation();

  return (
    <div className="topbar">
      {onBack && (
        <button
          className="topbar-back"
          onClick={onBack}
          aria-label={t("common.back", { defaultValue: "Back" })}
        >
          {/* ⬅️ نستخدم سهم يمين دائمًا */}
          <span className="icon">›</span>
        </button>
      )}

      <h1 className="topbar-title">{title}</h1>
    </div>
  );
}
